import type { ReportEvent } from '@/types/report';

export function getReportEventTime(event: ReportEvent): number | undefined {
    return event.videoStartSeconds ?? event.thumbnailFrames[0]?.time;
}
